import { PanelLeft, Sun, Moon } from "lucide-react";

interface Props {
	toggle: () => void;
	isExpanded: boolean;
	isDarkMode: boolean;
	toggleTheme: () => void;
}

const Topbar = (props: Props): JSX.Element => {
	const { toggle, isDarkMode, toggleTheme } = props;

	return (
		<div className="h-[72px] w-full flex items-center p-[15px] gap-2 sticky top-0 z-10 border-b border-border bg-background transition-[background-color,border-color] duration-300">
			<button
				onClick={toggle}
				title="Toggle Sidebar"
				className="w-7 h-7 flex items-center justify-center bg-transparent border-none rounded-md outline-none cursor-pointer text-foreground transition-colors duration-150 hover:bg-accent"
			>
				<PanelLeft size={16} />
			</button>
			<h1 className="text-lg font-semibold m-0 text-foreground">
				Hotelise
			</h1>
			<button
				onClick={toggleTheme}
				title="Toggle Theme"
				className="ml-auto w-7 h-7 flex items-center justify-center bg-transparent border-none rounded-md outline-none cursor-pointer text-foreground transition-colors duration-150 hover:bg-accent"
			>
				{isDarkMode ? <Sun size={16} /> : <Moon size={16} />}
			</button>
		</div>
	);
};

export default Topbar;
